import { selectProperStyles } from '../utils';
import { WidgetTileGridProps } from './WidgetGrid';

import styles from './WidgetGrid.module.scss';

export const getWidgetBannerStyle = (size: WidgetTileGridProps['size']) => {
  return selectProperStyles(
    {
      small: styles.jackpotBannerSmallForced,
      medium: styles.jackpotBannerMediumForced,
      default: [styles.jackpotBannerSmall, styles.jackpotBannerMedium],
    },
    size
  );
};

export const getRowStyle = (size: WidgetTileGridProps['size']) => {
  return selectProperStyles(
    {
      small: styles.rowSmallForced,
      medium: styles.rowMediumForced,
      default: [styles.rowSmall, styles.rowMedium],
    },
    size
  );
};
